import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class UserSessionService {
    localStorageSessionKey: string;
    filterArr: any[] = [];
    roleDetailsEnum: any;
    CurrentLoginUserID: number = 0;

    constructor() {
        this.localStorageSessionKey = environment.apiBaseUrl + '-AuthData';
    }

    create(session) {
        // jshint ignore:line
        this.setLocalStorageProperties(session);
    }

    update(session: any) {
        const data = this.getSharedData();
        Object.keys(data).forEach(e => {
            Object.keys(session).forEach(v => {
                if (e === v) {
                    data[v] = session[v];
                }
            });
        });;
        localStorage.setItem(this.localStorageSessionKey, JSON.stringify(data));
    }

    destroy() {
        // jshint ignore:line
        localStorage.removeItem('role');
        // localStorage.clear();
    }

    load() {
        // jshint ignore:line
        const jsonData = localStorage.getItem(this.localStorageSessionKey);
        return jsonData;
    }

    setLocalStorageProperties(session: any) {
        // jshint ignore:line
        localStorage.setItem(
            this.localStorageSessionKey,
            JSON.stringify(session)
        );
    }

    getSharedData(): any {
        const dataString = localStorage.getItem(this.localStorageSessionKey);
        return dataString ? JSON.parse(dataString) : {};
    }

    getValue(key: string): any {
        const data = this.getSharedData();
        return data[key];
    }

    getLocalStorageWithKey(key: any) {
        // jshint ignore:line
        return localStorage.getItem(key);
    }

    setLocalStorageWithKey(key: any, session: any) {
        // jshint ignore:line
        localStorage.setItem(key, JSON.stringify(session));
    }

    getPageUrl(key: any) {
        this.filterArr = [];
        const menu = JSON.parse(
            this.getLocalStorageWithKey('menucontrols') as string
        );
        const filterItems = menu.map((e: any) => {
            e.submenu.forEach((element: any) => {
                this.filterArr.push(element);
            });
        });
        const output = this.filterArr.find((e) => {
            return e.path === key;
        });
        // output.edit = true;
        // output.delete = true;
        // output.view = true;
        // output.approve = true;
        // output.copy = true;
        return output.controlAccess;
    }

    getUserIdFromSession() {
        const sessionDataString = localStorage.getItem(
            this.localStorageSessionKey
        );
        if (sessionDataString) {
            const localStorageData = JSON.parse(sessionDataString);
            this.CurrentLoginUserID = localStorageData?.id;
        }
        return this.CurrentLoginUserID;
    }
    userName(): string {
        const jsonData = localStorage.getItem(this.localStorageSessionKey);
        return jsonData == null ? '' : JSON.parse(jsonData).username;
    }
    RoleName(): string {
        const jsonData = localStorage.getItem(this.localStorageSessionKey);
        return jsonData == null ? '' : JSON.parse(jsonData).roleName;
    }

    getRoleTypeFromSession() {
        const sessionDataString = localStorage.getItem(
            this.localStorageSessionKey
        );
        if (sessionDataString) {
            const localStorageData = JSON.parse(sessionDataString);
            const roleList = localStorageData?.roleDetails;
            this.roleDetailsEnum = JSON.parse(roleList);

        }
        return this.roleDetailsEnum;
    }
}
